<div class="LeftMenu" id="LeftMenu">
    <div class="LeftMenu_Container">
        <div class="LeftMenu_GroupItems">
            <div class="LeftMenu_Item LeftMenu_Item--toggleBtn" uk-toggle="target: #LeftMenu_Item_ShopWindow">
				<span class="IconItem IconItem--menu">
					<img src="/assets/img/icon/menu.svg" uk-svg="" hidden="true">
                     <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve" class=" uk-svg" width="300" height="300" data-svg="/assets/img/icon/menu.svg">

   <path d="M133.1,143.4h-32.5c-5.6,0-10.2-4.6-10.2-10.2v-32.5c0-5.6,4.6-10.2,10.2-10.2h32.5c5.6,0,10.2,4.6,10.2,10.2
	v32.5C143.4,138.8,138.8,143.4,133.1,143.4z"></path>
<path d="M133.1,209.5h-32.5c-5.6,0-10.2-4.6-10.2-10.2v-32.5c0-5.6,4.6-10.2,10.2-10.2h32.5c5.6,0,10.2,4.6,10.2,10.2
	v32.5C143.4,204.9,138.8,209.5,133.1,209.5z"></path>
<path d="M199.4,143.4h-32.5c-5.6,0-10.2-4.6-10.2-10.2v-32.5c0-5.6,4.6-10.2,10.2-10.2h32.5c5.6,0,10.2,4.6,10.2,10.2
	v32.5C209.6,138.8,205,143.4,199.4,143.4z"></path>
<path d="M209.5,203l-5.5-22.4c-0.4-2.5-2.5-4.5-5.1-4.8l-0.3-2.3l0-0.1c-1.9-10.5-8-17.3-15.5-17.3c0,0,0,0,0,0
	c-7.6,0-13.7,6.8-15.6,17.2l-0.3,2.6h-0.1c-2.9,0-5.4,2.1-5.9,4.9l-4.5,22.4c-0.5,3.5,2.2,6.6,5.9,6.6h41.1
	C207.3,209.5,210,206.4,209.5,203z M172.2,175.7l0.2-1.8c1.5-7.9,5.6-13,10.6-13h0c5,0,9.2,5.2,10.6,13.1l0.2,1.6H172.2z"></path>
</svg>
				</span>
			</div>

            <div class="LeftMenu_BtnFilter LeftMenu_Item--toggleBtn" uk-toggle="target: #LeftMenu_Item_FilterWindow">
                <div class="LeftMenu_Item">
					<span class="IconItem IconItem--who">
						<img src="/assets/img/icon/Komu_1.svg" uk-svg>
					</span>
                    <div class="LeftMenu_Item_CheckedWho uk-hidden"
						[class.uk-hidden]="!filterService.activeTargetAudience"
						[style.background-image]="(filterService.activeTargetAudience && filterService.activeTargetAudience.image) ? 'url('+filterService.activeTargetAudience.image.file.uri+')' : false"></div>
                </div>

                <div class="LeftMenu_Item">
					<span class="IconItem IconItem--mapMarker">
						<img src="/assets/img/icon/Kuda.svg" uk-svg>
					</span>
                    <div class="LeftMenu_Item_CheckedWhere uk-hidden"
						[class.uk-hidden]="!filterService.activeActivity"
						[style.background-image]="(filterService.activeActivity && filterService.activeActivity.image) ? 'url('+filterService.activeActivity.image.file.uri+')' : false"></div>
                </div>
            </div>
        </div>

        <div class="LeftMenu_GroupItems">
			<a class="LeftMenu_Item" [ngClass]="!showScrollUp ? 'uk-invisible' : ''" href="#" uk-scroll>
				<span class="IconItem IconItem--arrowTop">
					<img src="/assets/img/icon/arrow-top.svg" uk-svg>
				</span>
			</a>
			
			<div class="LeftMenu_Item" id="LeftMenu_BtnPageNext">
				<span class="IconItem IconItem--arrowRight">
					<img src="/assets/img/icon/arrow_right.svg" uk-svg>
				</span>
			</div>
		
            <div class="LeftMenu_Item" id="LeftMenu_BtnPageBack">
				<span class="IconItem IconItem--arrowLeft">
					<img src="/assets/img/icon/arrow-left.svg" uk-svg>
				</span>
			</div>

				<div class="LeftMenu_Item" data-jivo="close" id="JivoChat">
					<div class="LeftMenu_Item_ConsultBtn">
							<span class="IconItem IconItem--consultLeft">
								<img src="/assets/img/icon/consult-left.svg" uk-svg>
							</span>
							<span class="IconItem IconItem--consultRight">
								<img src="/assets/img/icon/consult-right.svg" uk-svg>
							</span>
					</div>
				</div>
        </div>
    </div>

    <div class="LeftMenu_Panel LeftMenu_Item_ShopWindow uk-offcanvas" id="LeftMenu_Item_ShopWindow">
		<div class="uk-offcanvas-bar">
			<div class="LeftMenuShop LeftMenu_Panel_Content">
	            <h2>Магазин</h2>
				<shop-slider></shop-slider>
	        </div>
		</div>
    </div>

    <div class="LeftMenu_Panel LeftMenu_Item_FilterWindow uk-offcanvas" id="LeftMenu_Item_FilterWindow">
        <div class="uk-offcanvas-bar">
			<div class="LeftMenu_Panel_Content">
	            <app-filter></app-filter>
	        </div>
        </div>
    </div>

    <div class="LeftMenu_Panel LeftMenu_Item_ConsultWindow uk-offcanvas" id="LeftMenu_Item_ConsultWindow">
		<div class="uk-offcanvas-bar">
			<div class="LeftMenu_Panel_Content">
	            <app-consult></app-consult>
	        </div>
		</div>
    </div>
</div>
